
import { Vue, Component, Prop } from "vue-property-decorator";
import { getManagerName, getProductCateGory, createProduct, editProduct } from "@/api/product-category";
import { Product, Target } from "@/model/productCategory";

@Component
export default class ProductSystem extends Vue {
  public goals_show = false;
  public product_category = [];
  public dialogVisible = false;
  public type = "";
  @Prop({ required: true }) public ruleForm: Product = new Product();
  @Prop({ required: true }) private productManagers: any = [];
  // public ruleForm = {
  //   name: "",
  //   productCategoryId: "",
  //   productCategory: "",
  //   productCateGoryManager: "",
  //   managerId: "",
  //   devManagerId: "",
  //   productType: "",
  //   targetReq: new Target(),
  // }
  public btn_text = "转到品延产品";
  public rules = {
    productCategoryId: [{ required: true, message: "请选择产品系统", trigger: "blur" }],
    productCateGoryManager: [{ required: true, message: "请先选择产品系统经理", trigger: "blur" }],
    name: [{ required: true, message: "请输入华强品名", trigger: "blur" }],
    managerId: [{ required: true, message: "请选择产品经理", trigger: "change" }],
    devManagerId: [{ required: false, message: "请选择活动资源", trigger: "change" }],
    delivery: [
      { required: true, message: "请选择品延产品", trigger: "change" }
    ],
    desc: [{ required: true, message: "请填写品延产品经理", trigger: "blur" }]
  };
  private pro_type = "主打产品";

  // 点击切换产品类型
  changeProductType() {
    this.pro_type =
      this.pro_type === "主打产品" ? "品延产品" : "主打产品";
    this.btn_text =
      this.pro_type === "主打产品" ? "转到品延产品" : "转到主打产品";
  }

  async getProductCategory() {
    const data: any = await getProductCateGory();
    this.product_category = data.map(value => {
      return { value: value.id, label: value.name };
    });
  }

  async getManager() {
    const { id, name, managerName }: any = await getManagerName(this.ruleForm.productCategoryId);
    this.ruleForm.productCateGoryManager = managerName;
  }

  async createProduct() {
    await createProduct(this.ruleForm);
    this.dialogVisible = false;
    this.$emit("getList");
  }

  async editProduct() {
    await editProduct(this.ruleForm.id, this.ruleForm);
    this.dialogVisible = false;
    this.$emit("getList");
  }

  clear() {
    this.ruleForm = new Product();
  }

}
